import React, { createContext, useContext, useMemo, useState } from 'react'

const ReferralContext = createContext(null)

const useReferral = () => {
  const context = useContext(ReferralContext)
  if (!context) {
    throw new Error('useReferral must be used within a ReferralProvider')
  }
  return context
}

const ReferralProvider = props => {
  const [referral, setReferral] = useState(null)
  const value = useMemo(() => ({ referral, setReferral }), [referral])

  return <ReferralContext.Provider value={value} {...props} />
}

export { ReferralProvider, useReferral }
